import { useTranslations } from '@vocab/react';
import { TextField } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { TITLE_MAX_LENGTH } from '../../validation/validationRules';
import translations from './.vocab';

export const SimpleTitleQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  const { t } = useTranslations(translations);
  return (
    <TextField
      id="simpleTitle"
      label={t('Write a title for your review')}
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      characterLimit={TITLE_MAX_LENGTH}
      reserveMessageSpace
    />
  );
};
